"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FioSuggestions = void 0;
const react_1 = __importDefault(require("react"));
const base_suggestions_1 = require("./base-suggestions");
const highlight_words_1 = require("./highlight-words");
require("./types");
class FioSuggestions extends base_suggestions_1.BaseSuggestions {
    constructor() {
        super(...arguments);
        this.loadSuggestionsUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio';
        this.getLoadSuggestionsData = () => {
            const { count, filterGender, filterParts } = this.props;
            const { query } = this.state;
            const requestPayload = {
                query,
                count: count || 10,
            };
            if (filterGender) {
                requestPayload.gender = filterGender;
            }
            if (filterParts) {
                requestPayload.parts = filterParts;
            }
            return requestPayload;
        };
        this.getSuggestionKey = (suggestion) => `name:${suggestion.data.name || ''}surname:${suggestion.data.surname || ''}patronymic:${suggestion.data.patronymic || ''}`;
        this.renderOption = (suggestion) => {
            const { renderOption, highlightClassName } = this.props;
            const { query } = this.state;
            return renderOption ? (renderOption(suggestion, query)) : (react_1.default.createElement("div", null,
                react_1.default.createElement(highlight_words_1.HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: this.getHighlightWords(), text: suggestion.value })));
        };
    }
}
exports.FioSuggestions = FioSuggestions;
